import { styled } from '@volkswagen-onehub/components-core';
import { VWTheme } from '../../../../shared/typings/vw-theme';

export interface SubtitleAndCTAProps {
  theme: VWTheme;
}

export const SubtitleAndCTAContainer = styled.div`
  ${({ theme }: SubtitleAndCTAProps) => {
    return `
      align-items: center;
      align-self: stretch;
      display: flex;
      justify-content: space-between;
      padding-bottom: ${theme.size.static350};
      padding-top: ${theme.size.static400};
    `;
  }}
`;